module.exports = require("dagre-d3-renderer");


//////////////////
// WEBPACK FOOTER
// external "dagre-d3-renderer"
// module id = 30
// module chunks = 0